import theme, { createStyles,ThemeColors } from 'core/utilities/theme';

export default createStyles({
  paper: {
    background: ThemeColors.dropdownMenuBg,
    borderColor: ThemeColors.dropdownMenuBorder,
  },
  item: {
    paddingRight: theme.spacing(5),
    width: '100%',
  },
});
